/**
 * StepSiteBody.js
 *
 * Renders the body of the site selection step.
 * Orchestrates the search, picker, and confirmation views for sites.
 */
import React from 'react';
import PropTypes from 'prop-types';
import SearchFieldSites from './SearchFieldSites';
import SitePickerFromGoogle from './SitePickerFromGoogle';
import SiteConfirmationBox from './SiteConfirmationBox';

StepSiteBody.propTypes = {
  siteData: PropTypes.object.isRequired,
  zipCode: PropTypes.string,
  latitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  longitude: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChangeMultiple: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onSelectSite: PropTypes.func.isRequired,
  onNone: PropTypes.func.isRequired,
};

/**
 * Component for the body of the site selection step.
 *
 * @param {object} props - Component props.
 * @returns {JSX.Element} The rendered site step body.
 */
export default function StepSiteBody(props) {
  const { siteData, zipCode, latitude, longitude, onChangeMultiple, onInputChange, onSelectSite, onNone } = props;
  const isSearching = !siteData.siteId || siteData.type === 'Custom';
  const isPicking = siteData.type === 'GooglePlace' || siteData.type === 'CustomPlace';
  const isConfirmed = siteData.type === 'Site' || siteData.type === 'PotentialSite';

  return (
    <div className="min-w-80 max-w-[585px] flex flex-col gap-4 mb-12">
      {(isSearching || isConfirmed) && (
        <SearchFieldSites
          value={siteData.name}
          onChange={onChangeMultiple}
          onInputChange={onInputChange}
          zipCode={zipCode}
          latitude={latitude}
          longitude={longitude}
          hideDetails={isConfirmed}
        />
      )}
      {isPicking && (
        <SitePickerFromGoogle
          siteData={siteData}
          onSelectSite={onSelectSite}
          onNone={onNone}
        />
      )}
      {isConfirmed && (
        <SiteConfirmationBox
          siteData={siteData}
        />
      )}
    </div>
  );
}
